import { RouteRecordRaw } from 'vue-router';
import { defaultMetaPayment } from '../routesSetup';
import PaymentView from '../../lib/pages/PaymentView.vue';
import PaymentConfirmationView from '../../lib/pages/PaymentConfirmationView.vue';

// NB. Deliberately flat: unlike medical-request/admin-request, this tree has no shared
// "check it's not an emergency" interstitial and no requiresValidPatient step, so there is
// nothing for a parent route to guard. Both routes are reached only via a direct link
// containing the invoice id.
const paymentChildren: RouteRecordRaw[] = [
  {
    path: '',
    name: 'payment-pay',
    component: PaymentView,
    meta: {
      ...defaultMetaPayment,
      layoutPageTitle: 'Pay your invoice',
    },
  },
  {
    path: 'confirmation',
    name: 'payment-confirmation',
    component: PaymentConfirmationView,
    meta: {
      ...defaultMetaPayment,
      pageTitle: 'Payment confirmation',
      // The page renders its own heading (wording depends on webhook timing), so the
      // generic DefaultLayout banner heading is switched off here.
      layoutPageTitle: null,
    },
  },
];

export default paymentChildren;
